import { colord } from 'colord';
import { ColorPicker } from '../ColorPicker';
import { ColorPickerModalColorInputs } from './ColorPickerModalColorInputs';
import { ColorPickerModalColorSwatches } from './ColorPickerModalColorSwatches';

export const SolidColorPage = ({
  value,
  onChange,
  defaultSwatchesTarget,
}: {
  value?: string | null;
  onChange: (newValue: string | undefined) => void;
  defaultSwatchesTarget?: string;
}) => {
  const color = colord(value || 'transparent');
  const rgba = color.toRgb();

  return (
    <>
      <ColorPicker rgba={rgba} onChange={onChange} />
      <ColorPickerModalColorInputs value={value} onChange={onChange} />
      <ColorPickerModalColorSwatches onChange={onChange} defaultSwatchesTarget={defaultSwatchesTarget} />
    </>
  );
};
